import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css']
})
export class FileUploaderComponent implements OnInit {
  isHovering: boolean;
  files: File[] = [];
  error = '';
  @Output() fileDropped = new EventEmitter<File>();
  @Output() onError = new EventEmitter<string>();
  @Input() maxFileSize = 2 * 1024 * 1024; //Default 2 MB
  @Input() maxFileSizeErrorMessage = 'File size exceeds 2MB';

  constructor() {}

  ngOnInit(): void {}

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  onDrop(files: FileList) {
    if (!files || files.length === 0) {
      return;
    }
    if (files.length > 1) {
      this.setError('Please only upload one file at a time');
    } else if (files[0].type !== 'application/pdf') {
      this.setError('Please choose a pdf file for upload');
    } else if (files[0].size > this.maxFileSize) {
      this.setError(this.maxFileSizeErrorMessage);
    } else {
      this.fileDropped.emit(files[0]);
    }
  }

  setError(error) {
    this.error = error;
    this.onError.emit(error);
  }
}
